import styled from 'styled-components';

const CartWrapper = styled.div`
    .total-price-wrapper{

        width: 40%;
        margin-left: auto;
        
        h4{
            display: flex;
            justify-content: space-between;
        }

        .text {
            font-weight: normal;
        }

    }



`;

export default CartWrapper;